import { atom } from "recoil";

export const changePasswordStatus = atom({
  key: "changePassword",
  default: false,
});
